import request from '@/utils/request'

const defaultUrl = '/api/Chat/'

// 获取会话列表
export function getConversations() {
  return request({
    url: defaultUrl + 'GetConversations',
    method: 'get'
  })
}

// 获取消息历史
export function getMessages(conversationId) {
  return request({
    url: defaultUrl + 'GetMessages/' + conversationId,
    method: 'get'
  })
}

// 发送消息
export function sendMessage(data) {
  return request({
    url: defaultUrl + 'SendMessage',
    method: 'post',
    data
  })
}

// 创建或获取会话
export function createConversation(data) {
  return request({
    url: defaultUrl + 'CreateConversation',
    method: 'post',
    data
  })
}

// 标记已读
export function markAsRead(data) {
  return request({
    url: defaultUrl + 'MarkAsRead',
    method: 'post',
    data
  })
}

// 获取未读数
export function getUnreadCount() {
  return request({
    url: defaultUrl + 'GetUnreadCount',
    method: 'get'
  })
}

// 检查新消息（轮询）
export function checkNewMessages() {
  return request({
    url: defaultUrl + 'CheckNewMessages',
    method: 'get'
  })
}

// 根据会话ID获取会话信息
export function getConversation(conversationId) {
  return request({
    url: defaultUrl + 'GetConversation/' + conversationId,
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/chat.js